/*
 * Copyright (c) 2019. Nedaware SL
 */

import {environment} from '../../environments/environment';

export abstract class ApiInterface {
    public static readonly URL = new URL(environment.apiUrl);
    /** Roles de la API */
    public static readonly ROLES = {
        USER: 'ROLE_USUARIO',
        EMPLEADO: 'ROLE_EMPLEADO',
        ADMIN: 'ROLE_ADMIN',
        SUPERADMIN: 'ROLE_SUPERADMIN',
        GESTION: 'ROLE_GESTION',
        TECNICO: 'ROLE_TECNICO',
        COMERCIAL: 'ROLE_COMERCIAL',
        LOGISTICA: 'ROLE_LOGISTICA',
        DISENO: 'ROLE_DISENO'
    };
    /** Rol por defecto de todos los usuarios */
    public static readonly DEFAULT_ROLE = ApiInterface.ROLES.USER;
}
